import { FiseConsultasUser } from './FiseConsultasUser';
import { AccessRequestDTO } from './AccessRequestDTO';
import { AccessResponseDTO } from './AccessResponseDTO';
import { ResponseDTO } from '../models/common/ResponseDTO';
import { Constantes } from '../global/constantes';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { EncryptionService } from './encryption.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  //constantes
  private URL_END_POINT: string = `${environment.URL_BACKEND}/access`;
  private GNR_GENERIC_USER: string = `${environment.GNR_GENERIC_USER}`;
  private GNR_GENERIC_PASSWORD: string = `${environment.GNR_GENERIC_PASSWORD}`;
  private LOGIN_USUARIO_SESSION: string = 'loginUsuario';
  private TIPO_USUARIO_SESSION: string = 'tipoUsuario';
  private TOKEN_USUARIO_SESSION: string = 'tokenUsuario';

  //variables para almacenar datos del usuario
  private fiseConsultasUser: FiseConsultasUser;
  private loginUsuario: string;
  private tipoUsuario: string;
  private tokenUsuario: string;

  //variables para el acceso
  private pagina: string;

  constructor(
    private httpClient: HttpClient, 
    private router: Router,
    private encryptionService: EncryptionService,
  ) {
    const url = window.location.href;
    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      this.pagina = httpParams.get(Constantes.URL_PARAM_OPCION);
    }
  }

  private login(): Promise<void> {
    //para generar el access request
    let accessRequestDTO = new AccessRequestDTO();
    accessRequestDTO.loginUsuario = this.GNR_GENERIC_USER;
    accessRequestDTO.passwordUsuario = this.encryptionService.encrypt(this.GNR_GENERIC_PASSWORD);
    accessRequestDTO.tipoAcceso = Constantes.TIPO_USUARIO_GNR;
    //para intentar el login
    const endPoint = `${this.URL_END_POINT}/login`;
    return this.httpClient.post<ResponseDTO>(endPoint, accessRequestDTO)
      .toPromise()
      .then(respuesta => {
        if (respuesta.result == "success") {
          console.log("TEST SUCESS")
          this.guardarDatosUsuarioSession(respuesta.data as AccessResponseDTO);
          this.redireccionarA(this.pagina);
        } else {
          console.debug("Error al autenticar: " + respuesta.message);
          this.logout();
        }
      });
  }

  public logout(): void {
    this.fiseConsultasUser = new FiseConsultasUser();
    this.loginUsuario = null;
    this.tipoUsuario = null;
    this.tokenUsuario = null;
    sessionStorage.clear();
    sessionStorage.removeItem(this.LOGIN_USUARIO_SESSION);
    sessionStorage.removeItem(this.TIPO_USUARIO_SESSION);
    sessionStorage.removeItem(this.TOKEN_USUARIO_SESSION);
    this.router.navigate(['/sesiones/cerrar-sesion']);
  }

  private guardarDatosUsuarioSession(datosUsuario : AccessResponseDTO): void {
    this.fiseConsultasUser = new FiseConsultasUser();
    this.fiseConsultasUser.loginUsuario = datosUsuario.loginUsuario;
    this.fiseConsultasUser.tipoUsuario = datosUsuario.tipoUsuario;
    this.loginUsuario = datosUsuario.loginUsuario;
    this.tipoUsuario = datosUsuario.tipoUsuario;
    this.tokenUsuario = datosUsuario.token;
    sessionStorage.setItem(this.LOGIN_USUARIO_SESSION, this.loginUsuario);
    sessionStorage.setItem(this.TIPO_USUARIO_SESSION, this.tipoUsuario);
    sessionStorage.setItem(this.TOKEN_USUARIO_SESSION, this.token);
  }

  private redireccionarA(pagina : string): void {
    console.log("pagina")
    if (pagina != null && pagina != ""){
      this.router.navigate([Constantes.PAGINA_GNR[pagina]]);
    } else {
      this.router.navigate(['/dashboard/inicio']);
    }
  }

  public verificarSession(): Promise<void> {
    if (this.pagina) {
      return this.login();
    } else {
      if (!this.isAutenticado()) {
        this.logout();
      }
      /*
      Promise.resolve("fiseConsultasSession")
        .then((value) => {
          console.log("Ir al Inicio");
        });
        */
    }
  }

  public isAutenticado(): boolean {
    let payload = this.obtenerDatosToken(this.token);
    if (payload != null && payload.sub && payload.sub.length > 0 && !this.isTokenExpirado()) {
      return true;
    }
    return false; 
  }

  private isTokenExpirado(): boolean {
    let token = this.token;
    let payload = this.obtenerDatosToken(token);
    let now = new Date().getTime() / 1000;
    if (payload !== null && payload.exp < now) {
      return true;
    }
    return false;
  }

  private obtenerDatosToken(token: string): any {
    if (token != null) {
      const helper = new JwtHelperService();
      return helper.decodeToken(token);
    }
    return null;
  }

  public get usuario(): FiseConsultasUser {
    if (this.fiseConsultasUser != null) {
      return this.fiseConsultasUser;
    } else if (this.loginUsuario == null && sessionStorage.getItem(this.LOGIN_USUARIO_SESSION) != null) {
      this.fiseConsultasUser = new FiseConsultasUser();
      this.fiseConsultasUser.loginUsuario = sessionStorage.getItem(this.LOGIN_USUARIO_SESSION);
      this.fiseConsultasUser.tipoUsuario = sessionStorage.getItem(this.TIPO_USUARIO_SESSION);
      return this.fiseConsultasUser;
    } else {
      return new FiseConsultasUser();
    }
  }

  public get token(): string {
    if (this.tokenUsuario != null) {
      return this.tokenUsuario;
    } else if (this.tokenUsuario == null && sessionStorage.getItem(this.TOKEN_USUARIO_SESSION) != null) {
      this.tokenUsuario = sessionStorage.getItem(this.TOKEN_USUARIO_SESSION);
      return this.tokenUsuario;
    } else {
      return null;
    }
  }

}
